import Vue from 'vue'
import Router from 'vue-router'
import MainFrame from '@/components/MainFrame'
import Login from '@/components/Login'

//数据面板
import Dashboard from '@/components/Dashboard/Dashboard'


import Notice from '@/components/Set/Notice/Notice'
import Config from '@/components/Set/Config/Config'
import Banner from '@/components/Set/Banner/Banner'

import GoodsList from '@/components/Goods/GoodsList'

import UserList from '@/components/User/userList'
import AgentList from '@/components/User/agentList'
import PayinRecord from '@/components/Recharge/PayinRecord'
import DrawRecord from '@/components/Recharge/DrawRecord'
import PayList from '@/components/Recharge/payList'
import DrawList from '@/components/Recharge/drawList'
import RechargeRecord from '@/components/Record/rechargeRecord'
import ActionRecord from '@/components/Record/actionRecord'
import OrderList from '@/components/Order/orderList'

import heartBg from '@/components/Set/heartBg'

import App from '@/App.vue'

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    // 处理错误 跳转到重复路径上，忽略错误
    // console.error(err);
  });
};

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'App',
      component: App,
	  children:[
		  {
			path:'',
			component: MainFrame,
		  },
		  {
			name: 'Home',
			path: 'Home',
			component: MainFrame,
			children:[
				{
					path:'/heartBg',
					name:'heartBg',
					component:heartBg
				},{
					path:'/Dashboard',
					name:'Dashboard',
					component:Dashboard
				},{
					path:'/Set/Notice',
					name:'Notice',
					component:Notice
				},{
					path:'/Set/Config',
					name:'Config',
					component:Config
				},{
					path:'/Set/Banner',
					name:'Banner',
					component:Banner
				},{
					path:'/User/userList',
					name:'UserList',
					component:UserList
				},{
					path:'/User/agentList',
					name:'AgentList',
					component:AgentList
				},{
					path:'/GoodsList',
					name:'GoodsList',
					component:GoodsList
				},{
					path:'/Recharge/payList',
					name:'PayList',
					component:PayList
				},{
					path:'/Recharge/drawList',
					name:'DrawList',
					component:DrawList
				},{
					path:'/Order/orderList',
					name:'OrderList',
					component:OrderList
				},{
					path:'/Record/actionRecord',
					name:'ActionRecord',
					component:ActionRecord
				}
			]
		  }
	  ]
    },{
      path: '/Login',
      name: 'Login',
      component: Login
    }
  ]
})
